import { Button } from 'react-bootstrap';
import React from 'react';
import clsx from 'clsx';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { openUrlInNewTab } from '../../util/window-utils';
import useApi from '../../api/backendApiContext';
import { useMutation } from '@tanstack/react-query';
import { analyticsTrack } from '../../web-analytics/webAnalytics';

export const DownloadBusinessPlanButton = (props: {
  surveyVersion?: number | null;
  dataTest: string;
}) => {
  const { surveyVersion, dataTest } = props;
  const { businessPlanApi } = useApi();

  const fetchUrlAndOpenInNewTab = async () => {
    const businessPlanDownloadUrl = await businessPlanApi.getBusinessDownloadUrl();
    logger.info('Redirecting to s3 business plan file');

    if (!businessPlanDownloadUrl.url) {
      logger.error('Failed to get business plan download url');
      return;
    }
    openUrlInNewTab(businessPlanDownloadUrl.url, {
      analyticsEvent: AnalyticsEvent.BUSINESS_PLAN_URL_OPENED,
    });
  };

  const { isLoading, mutate: urlFetchMutation } = useMutation(fetchUrlAndOpenInNewTab, {
    onError: () => {
      analyticsTrack(AnalyticsEvent.BUSINESS_PLAN_URL_FAILED);
    },
  });

  const onDownloadClick = () => {
    if (!isLoading) urlFetchMutation();
  };

  return (
    <Button
      variant={!!surveyVersion ? 'primary' : 'light'}
      className={clsx('button-apply')}
      disabled={isLoading}
      data-test={dataTest}
      onClick={onDownloadClick}
    >
      {`Download`}
    </Button>
  );
};
